// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageBalanceHistoryCloseDto } from './IPageBalanceHistoryCloseDto';
import {
    IPageBalanceHistoryCloseDtoFromJSON,
    IPageBalanceHistoryCloseDtoFromJSONTyped,
    IPageBalanceHistoryCloseDtoToJSON,
    IPageBalanceHistoryCloseDtoToJSONTyped,
} from './IPageBalanceHistoryCloseDto';

/**
 * 
 * @export
 * @interface IClosesByAccountReportDto
 */
export interface IClosesByAccountReportDto {
    /**
     * 
     * @type {string}
     * @memberof IClosesByAccountReportDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IClosesByAccountReportDto
     */
    account_type?: IClosesByAccountReportDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClosesByAccountReportDto
     */
    account_description?: string;
    /**
     * 
     * @type {IPageBalanceHistoryCloseDto}
     * @memberof IClosesByAccountReportDto
     */
    balance_history_closes?: IPageBalanceHistoryCloseDto;
}

/**
* @export
* @enum {string}
*/
export enum IClosesByAccountReportDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IClosesByAccountReportDto interface.
 */
export function instanceOfIClosesByAccountReportDto(value: object): value is IClosesByAccountReportDto {
    return true;
}

export function IClosesByAccountReportDtoFromJSON(json: any): IClosesByAccountReportDto {
    return IClosesByAccountReportDtoFromJSONTyped(json, false);
}

export function IClosesByAccountReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClosesByAccountReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'balance_history_closes': json['balance_history_closes'] == null ? undefined : IPageBalanceHistoryCloseDtoFromJSON(json['balance_history_closes']),
    };
}

export function IClosesByAccountReportDtoToJSON(json: any): IClosesByAccountReportDto {
    return IClosesByAccountReportDtoToJSONTyped(json, false);
}

export function IClosesByAccountReportDtoToJSONTyped(value?: IClosesByAccountReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_number': value['account_number'],
        'account_type': value['account_type'],
        'account_description': value['account_description'],
        'balance_history_closes': IPageBalanceHistoryCloseDtoToJSON(value['balance_history_closes']),
    };
}

